export default __webpack_public_path__ + "static/media/hospital-place-icon.699c5082.svg";